import React, { useEffect, useState } from 'react';

import FormContainer from '../../../../components/FormContainer';
import Input from '../../../../components/Inputs/Input';
import Select from '../../../../components/Inputs/Select';
import Radio from '../../../../components/Inputs/Radio';
import DatepickerMui from '../../../../components/Inputs/DatepickerMui';
import CheckboxGroup from '../../../../components/Inputs/CheckboxGroup/index';
import Divider from '../../../../components/Divider';
import Button from '../../../../components/Button';
import Alert from '../../../../components/Alert';

import { createAdditions, createUpdates } from './createRequests';

import { useGlobal } from '../../../../contexts/Global/context';

import { cloneObject, translateContractsGroupsListToOptions, checkIsSupport } from '../../../../utils';
import createAlerts from './createAlerts';

import validators from '../../../../utils/defaultValidators';
import validate from '../../../../utils/validateForm';

import defaultSchema from './schema';

import { ContainerButton } from '../../../../styles/styles';

import * as S from './styles';
import Modal from '../../../../components/Modal';

function CadastrarUsuario({ dataUser, activeTab, setActiveTab, setEditDataForm }) {
    const { contractsGroupsList, dataActiveContract, setShowSupportModal } = useGlobal();

    const schema = cloneObject({
        ...defaultSchema,
        permissions: {
            ...defaultSchema.permissions,
            options: dataActiveContract.isSpecificContract
                ? defaultSchema.permissions.options.filter((permission) => [1, 4].includes(permission.codigo))
                : defaultSchema.permissions.options,
        },
    });

    const [dataForm, setDataForm] = useState(dataUser ? cloneObject(dataUser) : cloneObject(schema));

    const [dataAlerts, setDataAlerts] = useState([]);
    const [loadingRegister, setLoadingRegister] = useState(false);
    const [loadingUpdateUser, setLoadingUpdateUser] = useState(false);
    const [modalSpecificContract, setModalSpecificContract] = useState(false);

    function handleInputBlur(event) {
        const { id, name, value } = event.target;
        const key = id || name;

        const form = cloneObject(dataForm);

        // Valida as regras de negocio do campo e, caso haja erro, altera o indice error
        if (typeof validators[key] === 'function') validators[key](form);

        // Valida os campos obrigatorios sem valores
        if (form[key].required && !value) {
            form[key].error = form[key].requiredMessage || 'Preencha com um valor válido.';
        }

        setDataForm({ ...form });
    }

    function getPrincipalContracts(list) {
        return list.filter(({ contratoResponsavelGrupo }) => contratoResponsavelGrupo);
    }

    async function handleChangeInput(event) {
        const { id, value, unmaskedValue, lookup, clickedOption, ...rest } = event;

        const field = {
            ...cloneObject(dataForm[id]),
            value,
            lookup,
            unmaskedValue,
            error: '',
            ...rest,
        };

        if (id === 'contracts') {
            if (
                !dataActiveContract.isSpecificContract &&
                dataActiveContract.specificsContractsList.includes(clickedOption.code) &&
                rest.isChecked
            ) {
                setModalSpecificContract({ contract: clickedOption.name, visibility: true });
            }
        }

        const permissions = cloneObject(dataForm.permissions);

        if (id === 'typeUser') {
            permissions.required = value === 'MCE';
            permissions.error = '';
        }

        setDataForm({
            ...dataForm,
            permissions,
            [id]: { ...field },
        });
    }

    async function handleRegisterUser() {

        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        const { validatedForm, isValid } = validate(dataForm);

        setDataForm(validatedForm);

        if (!isValid) return;

        setLoadingRegister(true);

        const requestsToAdd = createAdditions(dataForm.contracts.value, dataForm, dataUser);

        const responses = await Promise.all(requestsToAdd);

        const alerts = createAlerts({ responses, requests: requestsToAdd });

        setDataAlerts(alerts);

        setDataForm(cloneObject({ ...schema, contracts: { ...dataForm.contracts, value: [] } }));

        setLoadingRegister(false);

        window.document.getElementById('page-content')?.scrollTo(0, 0);
    }

    async function handleUpdateUser() {

        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        const { validatedForm, isValid } = validate(dataForm);

        setDataForm(validatedForm);

        if (!isValid) return;

        setLoadingUpdateUser(true);

        const requestsToUpdate = createUpdates([dataForm.contracts.value], dataForm, dataUser);

        const requests = [...requestsToUpdate];

        const responses = await Promise.all(requests);

        const alerts = createAlerts({ responses, requests });

        setDataAlerts(alerts);

        setDataForm(cloneObject({ ...schema, contracts: { ...dataForm.contracts, value: [] } }));

        setLoadingUpdateUser(false);

        setEditDataForm(false);

        window.document.getElementById('page-content')?.scrollTo(0, 0);
    }

    function handleClearContracts() {
        if (dataForm.contracts?.value?.length > 0) {
            setDataForm({
                ...dataForm,
                contracts: { ...dataForm.contracts, value: [] },
            });
        }
    }

    useEffect(() => {
        if (!dataUser) return;

        const isAdmin = dataUser.typeUser.value === 'RH';

        const allowedContractsToEdit = isAdmin
            ? getPrincipalContracts(dataUser.contracts.options)
            : dataUser.contracts.options;

        setDataForm({
            ...cloneObject(dataUser),
            contracts: { ...cloneObject(dataUser.contracts), options: allowedContractsToEdit },
        });
    }, [dataUser]);

    useEffect(() => {
        setDataAlerts([]);
    }, [activeTab]);

    useEffect(() => {
        if (dataUser) return;

        const isAdmin = dataForm.typeUser.value === 'RH';

        const contracts = cloneObject(dataForm.contracts);

        const translatedOptions = translateContractsGroupsListToOptions(contractsGroupsList);

        if (isAdmin) {
            contracts.options = getPrincipalContracts(translatedOptions);

            contracts.value = getPrincipalContracts(
                translatedOptions.filter(({ codigo }) => contracts.value?.includes(codigo))
            ).map(({ codigo }) => codigo);

            setDataForm({
                ...dataForm,
                contracts,
            });

            return;
        }

        setDataForm({
            ...dataForm,
            contracts: { ...contracts, options: translatedOptions },
        });
    }, [dataForm.typeUser.value]);

    useEffect(() => {
        setDataForm({
            ...dataForm,
            contracts: {
                ...dataForm.contracts,
                options: translateContractsGroupsListToOptions(contractsGroupsList),
            },
        });
    }, []);

    return (
        <S.Container>
            {dataAlerts.map((alert) => (
                <Alert {...alert} />
            ))}

            <p>
                Nessa tela será possível configurar permissões específicas para o acesso de um novo usuário. Será
                permitido apenas 01 login por usuário que terá validade de 180 dias a partir da data de cadastramento.
            </p>

            <FormContainer>
                <S.SelectContainer>
                    <Select
                        multiple={!dataUser}
                        field={dataForm.contracts}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    {!dataUser && (
                        <S.LinkButton id="clearContracts" onClick={handleClearContracts}>
                            <span className={dataForm.contracts?.value?.length > 0 ? 'active' : ''}>
                                Limpar seleção
                            </span>
                        </S.LinkButton>
                    )}
                </S.SelectContainer>
                <Input field={dataForm.fullName} onBlur={handleInputBlur} onChange={handleChangeInput} />
                <DatepickerMui field={dataForm.birthUser} onBlur={handleInputBlur} onChange={handleChangeInput} />
                <Input field={dataForm.position} onBlur={handleInputBlur} onChange={handleChangeInput} />
                <Input
                    field={{ ...dataForm.email, disabled: !!dataUser }}
                    onBlur={handleInputBlur}
                    onChange={handleChangeInput}
                />
                <Input field={dataForm.cellphone} onBlur={handleInputBlur} onChange={handleChangeInput} />
                <Radio
                    field={{ ...dataForm.typeUser, disabled: !!dataUser }}
                    onBlur={handleInputBlur}
                    onChange={handleChangeInput}
                />
            </FormContainer>

            {dataForm.typeUser.value === 'MCE' && (
                <>
                    <Divider />

                    <h1>Selecione os itens com permissão de acesso</h1>
                    <p>Os itens selecionados abaixo permitirão que o novo usuário possa visualiza-los ou editá-los.</p>

                    <CheckboxGroup field={dataForm.permissions} columns={3} onChange={handleChangeInput} />
                </>
            )}

            <ContainerButton>
                {dataUser && (
                    <Button id="backStep" type="secondary" onClick={() => setActiveTab('2')}>
                        Cancelar
                    </Button>
                )}

                {!dataUser ? (
                    <Button
                        id="continueStep"
                        type="primary"
                        loading={loadingRegister}
                        disabled={loadingRegister}
                        onClick={handleRegisterUser}
                    >
                        Cadastrar
                    </Button>
                ) : (
                    <Button
                        id="continueStep"
                        type="primary"
                        loading={loadingUpdateUser}
                        disabled={loadingUpdateUser}
                        onClick={handleUpdateUser}
                    >
                        Atualizar
                    </Button>
                )}
            </ContainerButton>

            <Modal
                title="Atenção"
                subtitle={
                    <S.SpecificContractMessage>
                        <span>
                            Para o contrato <b>{modalSpecificContract.contract}</b> será permitido aplicar apenas
                            permissões de acesso aos menus:
                        </span>
                        <ul>
                            {dataForm.permissions.options
                                .filter(({ codigo }) => ['1', '4'].includes(codigo.toString()))
                                .map(({ nome }) => (
                                    <li>- {nome}</li>
                                ))}
                        </ul>
                    </S.SpecificContractMessage>
                }
                visible={modalSpecificContract.visibility}
                footer={null}
            >
                <Button type="primary" onClick={() => setModalSpecificContract({ contract: '', visibility: false })}>
                    Ok, entendi
                </Button>
            </Modal>
        </S.Container>
    );
}

export default CadastrarUsuario;
